import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Suspense, useEffect, useContext, useState, lazy } from "react";
import UserContext from "./Context/User/userContext";

import LoadingScreen from "./Helpers/LoadingScreen";
import ConfirmDialog from "./Helpers/ConfirmDialog";
import EasyAlert from "./Helpers/EasyAlert";

const Home = lazy(() => import("./Components/Home"));
const Login = lazy(() => import("./Components/Login"));
const Dashboard = lazy(() => import("./Components/Dashboard"));
const GetOutletBarcode = lazy(() => import("./Components/NonReport/GetOutletBarcode"));
const DashboardSalesDetail = lazy(() => import("./Components/CommonReports/DashboardSalesDetail"));
const RoomStatus = lazy(() => import("./Components/FrontOfficeReports/RoomStatus"));
const ReservationCalendar = lazy(() => import("./Components/FrontOfficeReports/ReservationCalendar"));
const ExpectedArrivals = lazy(() => import("./Components/FrontOfficeReports/ExpectedArrivals"));
const ExpectedDepartures = lazy(() => import("./Components/FrontOfficeReports/ExpectedDepartures"));
const CheckInReport = lazy(() => import("./Components/FrontOfficeReports/CheckInReport"));
const CheckOutReport = lazy(() => import("./Components/FrontOfficeReports/CheckOutReport"));
const DayBook = lazy(() => import("./Components/CommonReports/DayBook"));
const TableStatus = lazy(() => import("./Components/FnBReports/TableStatus/TableStatus"));
const TableDisplay = lazy(() => import("./Components/FnBReports/TableStatus/TableDisplay"));
const KOTDisplay = lazy(() => import("./Components/FnBReports/TableStatus/KOTDisplay"));
const ExciseReport = lazy(() => import("./Components/StoreReports/ExciseReport"));
const StoteStock = lazy(() => import("./Components/StoreReports/StoteStock"));
const PurchaseRegister = lazy(() => import("./Components/StoreReports/PurchaseRegister"));
const ItemWiseSale = lazy(() => import("./Components/FnBReports/ItemWiseSale"));
const GSTReport = lazy(() => import("./Components/FnBReports/GSTReport"));
const DailySalesReport = lazy(() => import("./Components/FnBReports/DailySalesReport"));
const CancelKotReport = lazy(() => import("./Components/FnBReports/CancelKotReport"));
const NegativeKotReport = lazy(() => import("./Components/FnBReports/NegativeKotReport"));
const Profile = lazy(() => import("./Components/UserComponents/Profile"));
const Download = lazy(() => import("./Components/Other/Download"));
const PointOfSalesReport = lazy(() => import("./Components/FnBReports/PointOfSalesReport"));
const AccountsSummary = lazy(() => import("./Components/AccountReports/AccountsSummary"));
const CashLedger = lazy(() => import("./Components/AccountReports/CashLedger"));
const BillReport = lazy(() => import("./Components/FnBReports/BillReport"));
const ComplimentoryKotReport = lazy(() => import("./Components/FnBReports/ComplimentoryKotReport"));

function App() {
  const context = useContext(UserContext);
  const { selectedHotel, setIsMobile } = context;
  const [appType, setAppType] = useState(null);

  useEffect(() => {
    let bsModal;

    const handlePopstate = () => {
      bsModal?.hide();
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) backdrop.remove();
    };

    window.addEventListener("resize", handleWindowSizeChange);
    window.addEventListener("popstate", handlePopstate);

    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
      window.removeEventListener("popstate", handlePopstate);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (selectedHotel && Boolean(selectedHotel.str1)) {
      setAppType(parseInt(selectedHotel.str3));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedHotel]);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 500);
  };

  const handleClick = (e) => {
    if (!e.target.closest(".sidebar-footer")) {
      const sidebar = document.querySelector(".sidebar");
      if (sidebar) sidebar.classList.remove("footer-menu-show");
    }
  };

  return (
    <div className="App" onClick={handleClick} onTouchStart={handleClick}>
      <LoadingScreen />
      <ConfirmDialog />
      <EasyAlert />
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route exact path="/" element={<Home appType={appType} />}>
            <Route
              index
              element={appType === 0 ? <GetOutletBarcode /> : <Dashboard />}
            />
            <Route
              path="home"
              element={appType === 0 ? <GetOutletBarcode /> : <Dashboard />}
            />
            <Route path="outlet-barcode" element={<GetOutletBarcode />} />
            <Route path="dx01dtl" element={<DashboardSalesDetail />} />
            <Route path="rx02cki" element={<RoomStatus />} />
            <Route path="rx03rcl" element={<ReservationCalendar />} />
            <Route path="rx04exr" element={<ExpectedArrivals />} />
            <Route path="rx05exd" element={<ExpectedDepartures />} />
            <Route path="rx06ckn" element={<CheckInReport />} />
            <Route path="rx07cko" element={<CheckOutReport />} />
            <Route path="crz02db" element={<DayBook />} />
            <Route path="fbx01ts" element={<TableStatus />} />
            <Route path="fbx02ts" element={<TableDisplay />} />
            <Route path="fbx03ts" element={<KOTDisplay />} />
            <Route path="srx01er" element={<ExciseReport />} />
            <Route path="srx02ss" element={<StoteStock />} />
            <Route path="srx03pr" element={<PurchaseRegister />} />
            <Route path="fbx04is" element={<ItemWiseSale />} />
            <Route path="fbx05gr" element={<GSTReport />} />
            <Route path="fbx06ds" element={<DailySalesReport />} />
            <Route path="fbx07ck" element={<CancelKotReport />} />
            <Route path="fbx08nk" element={<NegativeKotReport />} />
            <Route path="usx01up" element={<Profile />} />
            <Route path="fbx09ps" element={<PointOfSalesReport />} />
            <Route path="acr01rs" element={<AccountsSummary />} />
            <Route path="acr02xl" element={<CashLedger />} />
            <Route path="fbx11br" element={<BillReport />} />
            <Route path="fbx12ck" element={<ComplimentoryKotReport />} />
          </Route>

          <Route exact path="/login" element={<Login />} />
          <Route exact path="/downloads" element={<Download />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;